import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import Login from './pages/Login';
import OTPSetup from './pages/OTPSetup';
import Dashboard from './pages/Dashboard';
import Vendas from './pages/Vendas';
import NovaVenda from './pages/NovaVenda';
import ConsultaViabilidade from './pages/ConsultaViabilidade';
import FilaTratamento from './pages/FilaTratamento';
import VendasPagamento from './pages/VendasPagamento';
import Usuarios from './pages/Usuarios';
import Planos from './pages/Planos';
import ConfigApi from './pages/ConfigApi';
import Arquivos from './pages/Arquivos';
import CatalogoPlanos from './pages/CatalogoPlanos';
import ConsultaInfoSpy from './pages/ConsultaInfoSpy';
import HistoricoInfoSpy from './pages/HistoricoInfoSpy';
import InfoSpyPj from './pages/InfoSpyPj';
import HistoricoInfoSpyPj from './pages/HistoricoInfoSpyPj';
import ConsultaCadastral from './pages/ConsultaCadastral';
import ComoFunciona from './pages/ComoFunciona';
import WhatsAppConfig from './pages/WhatsAppConfig';
import AutomacaoValidacaoOk from './pages/AutomacaoValidacaoOk';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Routes>
            {/* Rotas públicas */}
            <Route path="/login" element={<Login />} />
            <Route path="/otp/setup" element={<OTPSetup />} />
            
            {/* Rotas protegidas */}
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
          
          <Route 
            path="/vendas" 
            element={
              <ProtectedRoute>
                <Vendas />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/vendas/consulta-viabilidade" 
            element={
              <ProtectedRoute roles={['admin', 'diretor', 'supervisor', 'vendedor']}>
                <ConsultaViabilidade />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/vendas/nova" 
            element={
              <ProtectedRoute roles={['admin', 'diretor', 'supervisor', 'vendedor']}>
                <NovaVenda />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/fila-tratamento" 
            element={
              <ProtectedRoute roles={['admin', 'diretor', 'backoffice', 'supervisor_bko']}>
                <FilaTratamento />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/vendas-pagamento" 
            element={
              <ProtectedRoute roles={['admin', 'diretor', 'supervisor', 'vendedor']}>
                <VendasPagamento />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/config-api" 
            element={
              <ProtectedRoute roles={['admin']}>
                <ConfigApi />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/whatsapp" 
            element={
              <ProtectedRoute roles={['admin']}>
                <WhatsAppConfig />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/usuarios" 
            element={
              <ProtectedRoute roles={['admin', 'diretor']}>
                <Usuarios />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/planos" 
            element={
              <ProtectedRoute roles={['admin', 'diretor']}>
                <Planos />
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/arquivos" 
            element={
              <ProtectedRoute roles={['admin', 'diretor', 'supervisor', 'vendedor']}>
                <Arquivos />
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/catalogo-planos" 
            element={
              <ProtectedRoute roles={['admin', 'diretor', 'supervisor', 'vendedor']}>
                <CatalogoPlanos />
              </ProtectedRoute>
            } 
          />

          {/* InfoSpy Routes */}
          <Route 
            path="/infospy" 
            element={
              <ProtectedRoute>
                <ConsultaInfoSpy />
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/infospy/historico" 
            element={
              <ProtectedRoute roles={['admin', 'diretor', 'supervisor', 'supervisor_bko', 'backoffice', 'vendedor']}>
                <HistoricoInfoSpy />
              </ProtectedRoute>
            } 
          />

          <Route
            path="/infospypj"
            element={
              <ProtectedRoute>
                <InfoSpyPj />
              </ProtectedRoute>
            }
          />

          <Route
            path="/infospypj/historico"
            element={
              <ProtectedRoute roles={['admin', 'diretor', 'supervisor', 'supervisor_bko', 'backoffice', 'vendedor']}>
                <HistoricoInfoSpyPj />
              </ProtectedRoute>
            }
          />

          <Route
            path="/consulta-cadastral"
            element={
              <ProtectedRoute>
                <ConsultaCadastral />
              </ProtectedRoute>
            }
          />

          <Route
            path="/did"
            element={
              <ProtectedRoute>
                <ComoFunciona />
              </ProtectedRoute>
            }
          />

          <Route
            path="/automacao/validacao-ok"
            element={
              <ProtectedRoute roles={['admin', 'diretor']}>
                <AutomacaoValidacaoOk />
              </ProtectedRoute>
            }
          />
          
          {/* Rota padrão */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          
          {/* Rota 404 */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
